import React from 'react';
import { Alert, Button, Spin } from 'antd';
import { useCatalogue } from './useCatalogue';
import CatalogueBrowser from './CatalogueBrowser';
import { useViewportHeight } from './useViewportHeight';
import AssetsByTiersDownloadButton from './AssetsByTiersDownloadButton';

export default function AdminAssetsSwitch() {
  const catalogue = useCatalogue('admin');
  const { ref, height } = useViewportHeight();
  return (
    <div className="ac-root ac-admin" ref={ref} style={{ height }}>
      {catalogue.error && (
        <Alert
          type="error"
          title={catalogue.error}
          action={<Button onClick={catalogue.reload}>Retry</Button>}
        />
      )}
      {!catalogue.data && catalogue.loading && <Spin />}
      {catalogue.data && (
        <CatalogueBrowser
          data={catalogue.data}
          admin
          reload={catalogue.reload}
          toolbarActions={<AssetsByTiersDownloadButton />}
        />
      )}
    </div>
  );
}
